import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import rootReducer from './redux/rootReducer'
import App from './App'
import './i18n'

import './sass/style.scss'

const middleware = getDefaultMiddleware({
  immutableCheck: false,
  serializableCheck: false,
  thunk: true,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
})

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root')
)